<template>
    <v-card>
        <v-card-title>
            <span class="headline" v-if="!edit">Add Session</span>
            <span class="headline" v-else>Edit Session</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <ValidationObserver ref="observer">
                    <form>
                        <v-row>
                            <v-col cols="6">
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <ValidationProvider v-slot="{ errors }" name="Date" rules="required">
                                        <v-text-field
                                                v-model="sessionForm.date"
                                                label="Date *"
                                                type="date"
                                                readonly
                                                :error-messages="errors"
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                        </ValidationProvider>
                                    </template>
                                    <v-date-picker
                                            v-model="sessionForm.date"
                                            type="date"
                                            no-title
                                            scrollable
                                            @change="menu = false"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">

                                <v-text-field
                                        readonly
                                        solo
                                        flat
                                        :value="sessionForm.date | formatDate"
                                ></v-text-field>


                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <ValidationProvider v-slot="{ errors }" name="Start Time" rules="required">
                                <v-text-field
                                        v-model="sessionForm.start"
                                        label="Start Time*"
                                        type="time"
                                        suffix="BST"
                                        :error-messages="errors"
                                        required
                                ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <ValidationProvider v-slot="{ errors }" name="Finish Time" rules="required">
                                <v-text-field
                                        v-model="sessionForm.finish"
                                        label="Finish Time *"
                                        type="time"
                                        suffix="BST"
                                        :error-messages="errors"
                                        required
                                ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12">
                                <ValidationProvider v-slot="{ errors }" name="Trainer" rules="required">

                                    <TrainerSelector
                                            v-model="sessionForm.trainerId"
                                            label="Trainer *"
                                            :errors="errors"
                                    />

                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12">
                                <ValidationProvider v-slot="{ errors }" name="Venue" rules="required">
                                    <TrainingCenterSelector
                                            v-model="sessionForm.trainingCenterId"
                                            :errors="errors"
                                    />
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                        v-model="sessionForm.location"
                                        label="Location"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                        v-model="sessionForm.locationDetail"
                                        label="Location Detail (postcode)"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </form>
                </ValidationObserver>
            </v-container>
            <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeEvent">Close</v-btn>
            <v-btn color="blue darken-1" text @click="submit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import moment from "moment"
    import TRAINING_SESSION_CREATE from "../../../graphql/TrainingSessionsCreate.gql";
    import TRAINING_SESSION_UPDATE from "../../../graphql/TrainingSessionsUpdate.gql";

    import TrainingCenterSelector from "../../AutoCompletes/TrainingCenterSelector";
    import TrainerSelector from "../../AutoCompletes/TrainerSelector";

    import {required} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    function initialState() {
        return {
            menu: null,
            edit: false,
            editId: null,
            updating: false,
            sessionForm: {
                trainerId: null,
                trainingClassId: null,
                trainingCenterId: null,
                date: null,
                start: "09:30",
                finish: "16:30",
                location: null,
                locationDetail: null,
            }
        }
    }

    export default {
        name: "training-session-create",
        components: {
            ValidationProvider,
            ValidationObserver,
            TrainingCenterSelector,
            TrainerSelector,
        },
        props: {
            classId: Number,
            selectedSession: Object,
        },
        data() {
            return initialState()
        },
        watch: {
            selectedSession: function () {
                this.assignEditSession()
            },
            updating(value) {
                this.$emit('updating', value);
                this.$store.dispatch('notification/loading', value)
            }
        },
        created() {
            if(this.selectedSession) {
                this.assignEditSession()
                this.edit = true
            }

            this.sessionForm.trainingClassId = this.classId;
        },
        methods: {
            closeEvent() {
                this.$emit('clickClose')
            },

            resetData() {
                Object.assign(this.$data, initialState());
                this.sessionForm.trainingClassId = this.classId;
            },

            assignEditSession(){
                this.sessionForm.trainerId = this.selectedSession.trainer.id
                this.sessionForm.trainingCenterId = this.selectedSession.trainingCenter.id
                this.sessionForm.date = this.selectedSession.date
                this.sessionForm.start = moment(this.selectedSession.start).format('hh:mm')
                this.sessionForm.finish = moment(this.selectedSession.finish).format('hh:mm')
                this.sessionForm.location = this.selectedSession.location
                this.sessionForm.locationDetail = this.selectedSession.locationDetail
                this.editId = this.selectedSession.id
                this.edit = true
            },

            submit() {
                this.$refs.observer.validate().then((valid) => {
                    if(valid) {
                        if(this.edit){
                            this.updateSession();
                        }else{
                            this.createSession();
                        }
                        this.$refs.observer.reset()
                    }
                })
            },

            updateSession() {
                const vars = this.prepareQueryVariables();
                vars.id = this.editId
                this.updating = true
                this.$apollo.mutate({
                    mutation: TRAINING_SESSION_UPDATE,
                    variables: vars,
                }).then(() => {
                    this.resetData();
                    this.$emit('complete')
                    this.updating = false
                    this.$store.dispatch('notification/addSuccess', 'Session successfully updated')
                }).catch((error) => {
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

            createSession() {
                this.updating = true
                this.$apollo.mutate({
                    mutation: TRAINING_SESSION_CREATE,
                    variables: this.prepareQueryVariables(),
                }).then(() => {
                    this.resetData();
                    this.$emit('complete')
                    this.updating = false
                    this.$store.dispatch('notification/addSuccess', 'Session successfully created')
                }).catch((error) => {
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

            prepareQueryVariables() {
                let vars = this.sessionForm
                vars.start = vars.date + ' ' + vars.start + ':00'
                vars.finish = vars.date + ' ' + vars.finish + ':00'

                return vars;
            },
        }
    }


</script>
